import {
	Menu,
	MenuItem,
	MenuList,
	MenuPopover,
	MenuTrigger,
	Toolbar,
	ToolbarButton,
} from "@fluentui/react-components";
import {
	MoreHorizontal24Filled,
	ArrowClockwise20Regular,
} from "@fluentui/react-icons";
import type { ToolbarProps } from "@fluentui/react-components";
import { useStyle } from "./style";
import { DebugInfoActions, DebugInfoKey, WindowReloadReason, useDebugStore } from "@/common/stores/persistingStores/debugStore";

export const TopBar = (props: Partial<ToolbarProps>) => {
	const classes = useStyle();
	const debugInfoActions = useDebugStore((state: DebugInfoActions) => state);

	return (
		<Toolbar
			aria-label="with Separeted Groups"
			{...props}
			className={classes.toolbar}
		>
			<div className={classes.container}>
				<span>
					<img
						className={classes.logo}
						src="/logo192.png"
						alt="CC4Teams logo"
					/>
				</span>
				<h2 className={classes.h2}>CC4Teams</h2>
			</div>

			<Menu>
				<MenuTrigger>
					<ToolbarButton aria-label="More" icon={<MoreHorizontal24Filled />} />
				</MenuTrigger>

				<MenuPopover>
					<MenuList>
						<MenuItem
							icon={<ArrowClockwise20Regular />}
							onClick={() => {
								debugInfoActions.pushDebugInfoItem(DebugInfoKey.WindowReloadTriggerEvents, WindowReloadReason.ReloadAppClickWhenTeamsAppIsNotInitialized);
								
								window.location.reload();
							}}
						>
							Reload app
						</MenuItem>
					</MenuList>
				</MenuPopover>
			</Menu>
		</Toolbar>
	);
};
